// extracted by mini-css-extract-plugin
export var link = "link-module--link--pawaY";